package com.macrofocus.eflux.ui

import react.Props

operator fun Props.set(key: String, value: dynamic) {
    asDynamic()[key] = value
}

inline fun Props.asMap() = js("Object")
    .entries(this)
    .unsafeCast<Array<Array<dynamic>>>()
    .map {
        it[0].unsafeCast<String>() to it[1]
    }.toMap()


